import i18n from '@/plugins/i18n';
import { sortOrder, sortFieldMapping } from '../SecretManager/sm.secret.types';

const TokenTableHeaders = () => [
  {
    key: 'tokenName',
    name: i18n.global.t('sm.tokenName'),
    width: '30%',
    sortable: true,
  },
  {
    key: 'endpointCount',
    name: i18n.global.t('sm.endpointCount'),
    width: '20%',
    sortable: true,
  },
  {
    key: 'updatedAt',
    name: i18n.global.t('lastModified'),
    sortable: true,
    width: '20%',
    dataType: Date,
  },
  {
    key: 'createdAt',
    name: i18n.global.t('createdOn'),
    sortable: true,
    width: '20%',
    dataType: Date,
  },
  {
    key: 'actionItems',
    name: i18n.global.t('sm.actionItems'),
    width: '10%',
    sortable: false,
  },
];

const EndpointListHeaders = [
  {
    key: 'name',
    name: i18n.global.t('sm.name'),
    width: '33%',
  },
  {
    key: 'domain',
    name: i18n.global.t('sm.url'),
    width: '33%',
  },
];

const clientId = 'CLIENT_ID';
const accessTokenUrl = 'ACCESS_TOKEN_URL';
const clientSecret = 'CLIENT_SECRET';
const scope = 'SCOPE';
const audience = 'AUDIENCE';
const resource = 'RESOURCE';

const SecretTypeList = [
  { name: i18n.global.t('sm.clientId'), value: clientId },
  { name: i18n.global.t('sm.access-url'), value: accessTokenUrl },
  { name: i18n.global.t('sm.client-secret'), value: clientSecret },
  { name: i18n.global.t('sm.scope'), value: scope },
  { name: i18n.global.t('sm.audience'), value: audience },
  { name: i18n.global.t('sm.resource'), value: resource },
];

const secretManagerRoute = '/sm/smSecretManager';

const tokenDefaultData = {
  tokenName: '',
  accessTokenUrl: '',
  clientId: '',
  clientSecret: '',
  scope: '',
  audience: '',
  resource: '',
};

export {
  TokenTableHeaders,
  SecretTypeList,
  clientId,
  accessTokenUrl,
  clientSecret,
  scope,
  audience,
  resource,
  secretManagerRoute,
  EndpointListHeaders,
  tokenDefaultData,
};
